module.exports = __webpack_public_path__ + "img/flythehike-logo.a021a820.png";